<script>
	// @ts-nocheck

	import {
		Toggle,
		TooltipImage,
		SelectWithClear,
		ColorInput
	} from '@shopboxai/sb-portal-components';
	import Accordion from './Accordion.svelte';
	import { sbAdmin } from '../utils/utils';

	export let options = {};
	export let platform = 'other';
	let copyBtnText = 'Copy grid styles';
	const copyStyles = (text) => {
		let val = JSON.stringify(text);
		sessionStorage.setItem('sbStylesCopy', val);
		copyBtnText = 'Copied!';

		setTimeout(() => {
			copyBtnText = 'Copy grid styles';
		}, 2000);
	};
	const pasteStyles = () => {
		let stylesCopy = sessionStorage.getItem('sbStylesCopy');
		options = JSON.parse(stylesCopy);
	};
	let isOpen = false;
</script>

{#if options != null}
	<section class="tour-step-7 style-options">
		<span
			><button class="secondary" on:click={copyStyles(options)}>{copyBtnText}</button>
			<button
				class="secondary paste-btn"
				class:visible={sessionStorage.getItem('sbStylesCopy')}
				on:click={pasteStyles}>Paste grid styles</button
			></span
		>
		<Accordion buttonText={'General styles'}>
			<Toggle labelText="Show brand" bind:value={options.general.brandEnabled} />
			<Toggle labelText="Hide grid item borders" bind:value={options.general.hideBorders} />

			<Toggle
				labelText="Center headings for carousels"
				bind:value={options.general.centerCarouselTitle}
			/>
			<!-- <Toggle labelText="Add to cart for carousels" bind:value={options.addToCart.enabled} /> -->
			<Toggle
				labelText="Alternate Carousel Controls Style"
				bind:value={options.general.carouselControlsMinimal}
			/>
			<div class="color-select">
				<label for="gbc">Grid item background</label>
				<ColorInput id="gbc" bind:value={options.general.backgroundColor} />
			</div>
			<div class="color-select">
				<label for="pcbc">Product card background</label>
				<ColorInput id="pcbc" bind:value={options.general.productCardBackgroundColor} />
			</div>
			<div class="color-select">
				<label for="bsc">Product banner "Sale"</label>
				<ColorInput id="bsc" bind:value={options.general.saleBannerColor} />
			</div>
			<div class="color-select">
				<label for="bnc">Product banner "New"</label>
				<ColorInput id="bnc" bind:value={options.general.newBannerColor} />
			</div>
			<div class="border-radius-preview">
				<div style="--border-radius: {options.general.itemBorderRadius}" />
				<label for="brp">Grid item border radius</label>
				<input
					id="brp"
					type="text"
					placeholder="Ex: 4px"
					bind:value={options.general.itemBorderRadius}
				/>
			</div>
		</Accordion>

		<Accordion buttonText={'Heading style'}>
			<div>
				<label for="hfz">Font size</label>
				<input id="hfz" type="text" placeholder="14px" bind:value={options.heading.size} />
			</div>
			<div>
				<label for="hff">Font family</label>
				<input id="hff" type="text" placeholder="serif" bind:value={options.heading.family} />
			</div>
			<div>
				<label for="hfw">Font weight</label>
				<input id="hfw" type="text" placeholder="600" bind:value={options.heading.weight} />
			</div>
			<div class="color-select">
				<label for="hfc">Heading color</label>
				<ColorInput id="hfc" bind:value={options.heading.color} />
			</div>
		</Accordion>
		<Accordion buttonText={'Product style'}>
			<div>
				<label for="tfz">Title font size</label>
				<input id="tfz" type="text" placeholder="14px" bind:value={options.text.size} />
			</div>
			<div>
				<label for="tff">Title font family</label>
				<input id="tff" type="text" placeholder="serif" bind:value={options.text.family} />
			</div>
			<div>
				<label for="tfw">Title font weight</label>
				<input id="tfw" type="text" placeholder="600" bind:value={options.text.weight} />
			</div>
			<div class="color-select">
				<label for="bnc">Title color</label>
				<ColorInput id="bnc" bind:value={options.text.color} />
			</div>
			<div>
				<label for="ta">Title Alignment</label>
				<SelectWithClear id={'ta'} bind:value={options.text.align}>
					<option value="left">Left</option>
					<option value="center">Center</option>
					<option value="right">Right</option>
				</SelectWithClear>
			</div>
		</Accordion>
		<Accordion buttonText={'Price styles'}>
			<div>
				<label for="pfs">Font Size</label>
				<input id="pfs" type="text" placeholder="12px" bind:value={options.price.size} />
			</div>
			<div>
				<label for="pff">Font family</label>
				<input
					id="pff"
					type="text"
					placeholder="monospace, sans-serif"
					bind:value={options.price.family}
				/>
			</div>
			<div>
				<label for="pfw">Font weight</label>
				<input id="pfw" type="text" placeholder="bold" bind:value={options.price.weight} />
			</div>
			<div class="color-select">
				<label for="pc">Color</label>
				<ColorInput id="pc" bind:value={options.price.color} />
			</div>
			<div>
				<label for="spc">Sale price color</label>
				<ColorInput id="spc" bind:value={options.price.saleColor} />
			</div>
			<div>
				<label for="spfw">Sale price font weight</label>
				<input
					id="spfw"
					type="text"
					placeholder="normal"
					bind:value={options.price.saleFontWeight}
				/>
			</div>
			<div>
				<label for="pa">Price alignment</label>
				<SelectWithClear id={'pa'} bind:value={options.price.align}>
					<option value="left">Left</option>
					<option value="center">Center</option>
					<option value="right">Right</option>
				</SelectWithClear>
			</div>
			<div>
				<label for="spp"
					>Sale price position <TooltipImage
						src="https://hub.shopbox.ai/img/grid-builder/tooltips/price-order-tooltip.png"
					/>
				</label>
				<SelectWithClear id={'spp'} bind:value={options.price.saleOrder}>
					<option value="1">Normal Price First</option>
					<option value="-1">Sale Price First</option>
				</SelectWithClear>
			</div>
		</Accordion>
		<Accordion buttonText={'Image styles'}>
			<div>
				<label for="icm"
					>Image cover method <TooltipImage
						src="https://hub.shopbox.ai/img/grid-builder/tooltips/image-cover-method.png"
					/></label
				>
				<SelectWithClear id={'icm'} bind:value={options.imageStyles.coverMethod}>
					<option value="cover">Cover</option>
					<option value="contain">Contain</option>
				</SelectWithClear>
			</div>
			<div>
				<label for="iar">Image aspect ratio</label>
				<SelectWithClear id={'iar'} bind:value={options.imageStyles.aspectRatio}>
					<option value="1/1">1/1</option>
					<option value="2/3">2/3</option>
					<option value="3/4">3/4</option>
					<option value="4/3">4/3</option>
					<option value="5/3">5/3</option>
					<option value="16/9">16/9</option>
				</SelectWithClear>
			</div>
			<div>
				<label for="imh">Image max height</label>
				<input
					type="text"
					id="imh"
					placeholder="200px"
					bind:value={options.imageStyles.maxHeight}
				/>
			</div>
		</Accordion>
		<Accordion buttonText={'See more  styles'}>
			<div>
				<label for="smt">Text</label>
				<input id="smt" type="text" placeholder="See more" bind:value={options.seeMore.text} />
			</div>
			<div>
				<label for="smfz">Font size</label>
				<input id="smfz" type="text" placeholder="14px" bind:value={options.seeMore.size} />
			</div>
			<div>
				<label for="smff">Font family</label>
				<input id="smff" type="text" placeholder="serif" bind:value={options.seeMore.family} />
			</div>
			<div>
				<label for="smfw">Font weight</label>
				<input id="smfw" type="text" placeholder="600" bind:value={options.seeMore.weight} />
			</div>
			<div>
				<label for="smtd">Button text style</label>
				<SelectWithClear id={'smtd'} bind:value={options.seeMore.textDecoration}>
					<option value="underline">Underline</option>
					<option value="none">No decoration</option>
				</SelectWithClear>
			</div>
			<div class="color-select">
				<label for="smfc">Color</label>
				<ColorInput id="smfc" bind:value={options.seeMore.color} />
			</div>
		</Accordion>
		{#if platform == 'shopify' || platform == 'magento2'}
			<Accordion buttonText={'Add to cart styles'}>
				<div>
					<Toggle labelText="Show button" bind:value={options.addToCart.enabled} />
				</div>
				<div>
					<label for="atct">Add to cart text</label>
					<input
						id="satctmt"
						type="text"
						placeholder="See more"
						bind:value={options.addToCart.text}
					/>
				</div>
				<div>
					<label for="atct">Other variants text</label>
					<input
						id="satctmt"
						type="text"
						placeholder="See more"
						bind:value={options.addToCart.variantsText}
					/>
				</div>
				<div>
					<label for="atcfz">Font size</label>
					<input id="atcfz" type="text" placeholder="14px" bind:value={options.addToCart.size} />
				</div>
				<div>
					<label for="atcff">Font family</label>
					<input id="atcff" type="text" placeholder="serif" bind:value={options.addToCart.family} />
				</div>
				<div>
					<label for="atcfw">Font weight</label>
					<input id="atcfw" type="text" placeholder="600" bind:value={options.addToCart.weight} />
				</div>
				<div>
					<label for="atctd">Text style</label>
					<SelectWithClear id={'atctd'} bind:value={options.addToCart.textDecoration}>
						<option value="underline">Underline</option>
						<option value="none">No decoration</option>
					</SelectWithClear>
				</div>
				<div class="color-select">
					<label for="atcfc">Color</label>
					<ColorInput id="atcfc" bind:value={options.addToCart.color} />
				</div>
				<div class="color-select">
					<label for="atcfbc">Background Color</label>
					<ColorInput id="atcfbc" bind:value={options.addToCart.background} />
				</div>
				<div>
					<label for="atcm">Margin </label>
					<input id="atcm" type="text" placeholder="0px" bind:value={options.addToCart.margin} />
				</div>
				<div>
					<label for="atcp">Padding </label>
					<input id="atcp" type="text" placeholder="0px" bind:value={options.addToCart.padding} />
				</div>
			</Accordion>
		{/if}
		<Accordion buttonText={'Find Similar Button'}>
			<div>
				<Toggle labelText="Show button" bind:value={options.findSimilar.enabled} />
			</div>

			<div>
				<label for="fsbfz">Font size</label>
				<input id="fsbfz" type="text" placeholder="14px" bind:value={options.findSimilar.size} />
			</div>
			<div>
				<label for="fsbff">Font family</label>
				<input id="fsbff" type="text" placeholder="serif" bind:value={options.findSimilar.family} />
			</div>
			<div>
				<label for="fsbfw">Font weight</label>
				<input id="fsbfw" type="text" placeholder="600" bind:value={options.findSimilar.weight} />
			</div>
			<div>
				<label for="fsbtd">Text style</label>
				<SelectWithClear id={'fsbtd'} bind:value={options.findSimilar.textDecoration}>
					<option value="underline">Underline</option>
					<option value="none">No decoration</option>
				</SelectWithClear>
			</div>
			<div class="color-select">
				<label for="fsbfc">Color</label>
				<ColorInput id="fsbfc" bind:value={options.findSimilar.color} />
			</div>
			<div class="color-select">
				<label for="fsbfbc">Background Color</label>
				<ColorInput id="fsbfbc" bind:value={options.findSimilar.background} />
			</div>
			<div>
				<label for="afsb">Margin </label>
				<input id="fsbm" type="text" placeholder="0px" bind:value={options.findSimilar.margin} />
			</div>
			<div>
				<label for="fsbp">Padding </label>
				<input id="fsbp" type="text" placeholder="0px" bind:value={options.findSimilar.padding} />
			</div>
		</Accordion>
	</section>
{/if}

<style>
	.paste-btn {
		display: none;
	}
	.paste-btn.visible {
		display: inline-block;
	}
	.color-select,
	.border-radius-preview {
		position: relative;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.color-select label,
	.border-radius-preview label {
		white-space: nowrap;
		font-size: 14px;
		font-weight: 100 !important;
		position: absolute;
		top: 3px;
		left: 60px;
		color: var(--t-c-l);
		z-index: 1;
	}
	.style-options :global(.clr-field button) {
		width: 55px;
		height: 80%;
		left: 0;
		top: 20px;
		right: auto;
		border-radius: 3px;
	}
	.style-options :global(input.coloris),
	.border-radius-preview input {
		border: none !important;
		padding: 20px 5px 5px 60px;
	}
	.style-options :global(input.coloris:focus),
	.border-radius-preview input:focus {
		outline: none;
	}
	.border-radius-preview::after {
		content: '';
		position: absolute;
		height: 65%;
		width: 55px;
		top: 0;
		left: 0;
		border: 1px solid #dedee0;
		border-radius: 3px;
	}
	.border-radius-preview div {
		--border-radius: null;
		position: absolute;
		width: 20px;
		height: 20px;
		top: 10px;
		left: 20px;
		border-left: 2px solid #a1a0a5;
		border-top: 2px solid #a1a0a5;
		border-top-left-radius: var(--border-radius);
	}
	input {
		display: block;
		width: 100%;
		padding: 12px 6px;
		margin-bottom: 1em;
		border: 1px solid #727178;
		border-radius: 3px;
	}
	label {
		font-family: 'Overpass';
		font-weight: 800;
		font-size: 14px;
		line-height: 18px;
		color: #727178;
	}
</style>
